import { CORE_API } from "./envVariables";

let _baseURL = CORE_API;
export const baseURL = _baseURL;

console.info("Base URL", baseURL);
